import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';
import { GENERATE_FORM_URL_MAP, URL_PARAMS } from '../consts';

interface IProps {
    formType: string;
    formId: string;
    year: number;
}
export const useGenerateForm = ({ formType, formId, year }: IProps) => {
  const { customerId } = useStore(state => state.user);
  const dynamicUrl = GENERATE_FORM_URL_MAP[formType as keyof typeof GENERATE_FORM_URL_MAP];
  const formattedUrl = dynamicUrl
    .replace(URL_PARAMS.customerId, customerId)
    .replace(URL_PARAMS.formId, formId);
  return useMutation(
    'GenerateForm',
    async () => {
      const res = await httpService.put(formattedUrl, { year }, { responseType: 'blob' });
      return res.data;
    },
    {},
  );
};
